import angular from 'angular';
import ngResource from 'angular-resource';

function PlansServ($q, $http) {
	function addFilter(filter) {
		var defaults = $http.defaults.transformResponse;
		defaults = angular.isArray(defaults) ? defaults : [defaults];
		return defaults.concat(filter);
	}
	class Plan {
		constructor(plan) {
			angular.extend(this, plan);
		}

		getStorageStr() {
			return this.limits.storageGB > 0 ? (this.limits.storageGB / 1000).toFixed(0) + ' TB' : 'Unlimited';
		}
		getContributorStr() {
			return this.limits.contributors > 0 ? this.limits.contributors : 'Unlimited';
		}
	}

	function getAll() {
		return $http({
			url: '/plans',
			method: 'GET',
			isArray: true,
			transformResponse: addFilter(function (data) {
				return data.map(function (plan) {
					return new Plan(plan);
				});
			})
		})
	}
	return {
		getAll: getAll
	};
}
PlansServ.$inject = ['$q', '$http'];

export default angular.module('services.plans', [ngResource])
	.factory('Plans', PlansServ)
	.name;



// WEBPACK FOOTER //
// ./project/services/plans.js